import { createAction, handleActions } from 'redux-actions'

const setFilters = createAction("SCREENS/INVOICES/SET_FILTERS")

const defaultState = {
  type: 'ALL',
  client_id: [],
  date_between: undefined,
}

const reducer = handleActions(
  {
    [setFilters]: (state, action) => Object.assign({}, state, action.payload),
  },
  defaultState
)

export { setFilters, reducer }
